<template>
    <LoginRedirect :currentStep="0" :allDone="false" />
</template>

<script>
// Branded enterprise SSO entry (Epic CORE-6317 F9): /{slug}/login.
// Kicks off an OIDC sign-in tagged with the customer slug so the Identity Server
// routes to its branded /{slug}/login → Entra. Mirrors the IS-side /{slug}/login route.
import LoginRedirect from '../../../components/LoginRedirect';

export default {
    components: { LoginRedirect },
    async created() {
        const slug = (this.$route.params.slug || '').toLowerCase();
        try {
            await window.auth.loginWithSso(slug);
        } catch (e) {
            console.error('SSO login initiation failed:', e);
            this.$router.push({ path: '/login' });
        }
    }
};
</script>
